/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { publicApiNames, allowedRHPPositions } from "publicApis/constants";
import { apiFactory } from "api/external/ApiFactory";
import { isNonEmptyString } from "utils/APIUtils";

export const getRHPApis = stores => {
  function beforeOpenPanel(callback, opts) {
    const rhpRef = stores.appStore.rhpRefValue;
    if (rhpRef && typeof callback === "function") {
      rhpRef.getPublicApis().then(apis => apis.beforeOpenPanel(callback, opts));
    }
  }

  function beforeClosePanel(callback, opts) {
    const rhpRef = stores.appStore.rhpRefValue;
    if (rhpRef && typeof callback === "function") {
      rhpRef.getPublicApis().then(apis => apis.beforeClosePanel(callback, opts));
    }
  }

  function openPanel(dropinId, opt = {}) {
    if (isNonEmptyString(dropinId)) {
      const rhpRef = stores.appStore.rhpRefValue;
      if (rhpRef) {
        return rhpRef.getPublicApis().then(apis => apis.openPanel(dropinId, opt));
      }
    }
    return Promise.resolve(false);
  }

  function closePanel() {
    const rhpRef = stores.appStore.rhpRefValue;
    if (rhpRef) {
      return rhpRef.getPublicApis().then(apis => apis.closePanel());
    }
    return Promise.resolve(false);
  }

  function subscribe(callback) {
    const rhpRef = stores.appStore.rhpRefValue;
    if (rhpRef && typeof callback === "function") {
      return rhpRef.getPublicApis().then(apis => apis.subscribe(callback));
    }
    return Promise.resolve(false);
  }

  function unsubscribe(callback) {
    const rhpRef = stores.appStore.rhpRefValue;
    if (rhpRef && typeof callback === "function") {
      return rhpRef.getPublicApis().then(apis => apis.unsubscribe(callback));
    }
    return Promise.resolve(false);
  }

  function getConfig() {
    const rhpRef = stores.appStore.rhpRefValue;
    if (rhpRef) {
      return rhpRef.getPublicApis().then(apis => apis.getConfig());
    }
    return Promise.resolve(false);
  }

  function show(visibility) {
    stores.documentStore.setRhpVisibility(visibility);
  }

  function addUIControl(options = {}) {
    const { controls, position } = options;
    if (!controls || !Array.isArray(controls)) {
      return Promise.resolve(false);
    }
    if (position && !allowedRHPPositions.includes(position)) {
      return Promise.resolve(false);
    }
    stores.skinnyRailStore.setCustomVerbsGroup(options);
    return Promise.resolve(true);
  }

  return {
    beforeOpenPanel,
    beforeClosePanel,
    openPanel,
    closePanel,
    subscribe,
    unsubscribe,
    getConfig,
    show,
    addUIControl
  };
};

export const registerRHPApis = stores => {
  apiFactory.registerApi(publicApiNames.RHP, clientName => getRHPApis(stores), true);
};
